import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7cd9504e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "base-title-button" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "add_circle", -1))
const _hoisted_3 = {
  key: 1,
  class: "flex-grow-1"
}
const _hoisted_4 = { class: "table table-hover table-v2" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, " ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  colspan: "5",
  class: "fw-bold small text-uppercase text-muted"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_offcanvas_button_open = _resolveComponent("base-offcanvas-button-open")!
  const _component_BaseTitle = _resolveComponent("BaseTitle")!
  const _component_AlertError2 = _resolveComponent("AlertError2")!
  const _component_base_spinner = _resolveComponent("base-spinner")!
  const _component_DpMainCategoryRow = _resolveComponent("DpMainCategoryRow")!
  const _component_CustomerMainCategoryRow = _resolveComponent("CustomerMainCategoryRow")!
  const _component_base_container = _resolveComponent("base-container")!
  const _component_CustomerMainCategory = _resolveComponent("CustomerMainCategory")!
  const _component_base_offcanvas = _resolveComponent("base-offcanvas")!
  const _component_DPMainCategory = _resolveComponent("DPMainCategory")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_base_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_BaseTitle, {
          title: _ctx.$t('mainCategories'),
          mb: 4
        }, {
          buttons: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_base_offcanvas_button_open, {
                "offcanvas-id": "offcanvas-customer-main-category",
                class: "btn btn-hover icon-link",
                onBeforeOpen: _ctx.prepareCustomerOffCanvasForNewCategory
              }, {
                default: _withCtx(() => [
                  _hoisted_2,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('add')), 1)
                ]),
                _: 1
              }, 8, ["onBeforeOpen"])
            ])
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(_component_AlertError2, {
          error: _ctx.pageUI.getError()
        }, null, 8, ["error"]),
        (!_ctx.pageUI.getIsReady())
          ? (_openBlock(), _createBlock(_component_base_spinner, { key: 0 }))
          : _createCommentVNode("", true),
        (_ctx.pageUI.isReady())
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("table", _hoisted_4, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _hoisted_5,
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('name')), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('customerName')), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('image')), 1),
                    _hoisted_6
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_ctx.sortedCategories.length === 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
                        _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.$t('noResults')), 1)
                      ]))
                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.sortedCategories, (categoryItem) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: _ctx.getCategoryKey(categoryItem)
                        }, [
                          (categoryItem.type === 'dp')
                            ? (_openBlock(), _createBlock(_component_DpMainCategoryRow, {
                                key: 0,
                                category: categoryItem.category,
                                "master-categories": _ctx.masterCategories?.dp_main_categories ?? [],
                                onUpdateStatus: _ctx.updateStatus,
                                onEditCategory: _ctx.prepareDPOffCanvasForEditCategory
                              }, null, 8, ["category", "master-categories", "onUpdateStatus", "onEditCategory"]))
                            : (_openBlock(), _createBlock(_component_CustomerMainCategoryRow, {
                                key: 1,
                                category: categoryItem.category,
                                onUpdateStatus: _ctx.updateStatus,
                                onEditCategory: _ctx.prepareCustomerOffCanvasForEditCategory,
                                onDeleteCategory: _ctx.deleteCustomerMainCategory
                              }, null, 8, ["category", "onUpdateStatus", "onEditCategory", "onDeleteCategory"]))
                        ], 64))
                      }), 128))
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_base_offcanvas, {
      title: _ctx.$t('customerMainCategory'),
      id: "offcanvas-customer-main-category",
      class: "offcanvas-wider"
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_component_CustomerMainCategory, {
          key: _ctx.customerMainCategorySequence,
          code: _ctx.customerMainCategoryCode,
          mode: _ctx.customerMainCategoryMode,
          "all-languages": _ctx.allLanguages,
          "root-category-code": _ctx.rootCategoryCode,
          onEdit: _ctx.reloadContent
        }, null, 8, ["code", "mode", "all-languages", "root-category-code", "onEdit"]))
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_component_base_offcanvas, {
      title: _ctx.$t('dpMainCategory'),
      id: "offcanvas-dp-main-category",
      class: "offcanvas-wider"
    }, {
      default: _withCtx(() => [
        (_ctx.dpMainCategory)
          ? (_openBlock(), _createBlock(_component_DPMainCategory, {
              category: _ctx.dpMainCategory,
              "master-category": _ctx.getMasterCategory(_ctx.dpMainCategory.category.code),
              key: _ctx.dpMainCategorySequence,
              "all-languages": _ctx.allLanguages,
              onEdit: _ctx.reloadContent
            }, null, 8, ["category", "master-category", "all-languages", "onEdit"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["title"])
  ], 64))
}